export default "__VITE_ASSET__86a213ff__"